export default __webpack_public_path__ + "static/media/N373AF-Outside.dba28678.png";